import { render, staticRenderFns } from "./jobReqDetail.vue?vue&type=template&id=efec1536&scoped=true"
import script from "./jobReqDetail.vue?vue&type=script&lang=js"
export * from "./jobReqDetail.vue?vue&type=script&lang=js"
import style0 from "./jobReqDetail.vue?vue&type=style&index=0&id=efec1536&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efec1536",
  null
  
)

export default component.exports